import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const updateInformationRequest = (user, data) =>
  axios.patch(Routes.user_user_path(user.id, user.id), {
    user: data,
  });

export default updateInformationRequest;
